import { DemoInvoiceReceiverEnum } from '../payment/invoice-receiver.js';
export { DemoInvoiceReceiverEnum } from '../payment/invoice-receiver.js';
import { Address } from '@adornis/address/db/address.js';
import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { registerEnum } from '@adornis/baseql/metadata/register.js';
import type { RegistrationStammdatenPlugin } from '@adornis/buchungsheld-db/db-plugins.js';
import { UserStammdaten } from '@adornis/buchungsheld-db/entities/stammdaten.js';
import { validate } from '@adornis/validation/decorators.js';
import { MultipleValidationError } from '@adornis/validation/errors/MultipleValidationError.js';
import { ValidationError } from '@adornis/validation/errors/ValidationError.js';
import { and } from '@adornis/validation/functions/and.js';
import { nonOptional } from '@adornis/validation/functions/nonOptional.js';

export const demoRegistrationStammdatenPlugin: RegistrationStammdatenPlugin = {
  id: 'registration::stammdaten::demo',
  type: 'registration::stammdaten',
  disableCustomFormfields: true,
  createStammdaten: async ({ userID, institutionID, createInDB } = {}) => {
    const stammdaten = new DemoStammdaten({ userID, institutionID });
    if (createInDB) await stammdaten.create();
    return stammdaten;
  },
  // customValidate: (stammdaten: DemoStammdaten) => {
  // },
  getFields: () => {
    return Object.keys(DemoStammdaten.fields).filter(it => !['_id', '_class', 'userID', 'institutionID'].includes(it));
  },
  classType: () => DemoStammdaten,
};

export enum DemoSalutationEnum {
  DEMOFRAU = 'DEMOFRAU',
  DEMOHERR = 'DEMOHERR',
  DEMOSONSTIGES = 'DEMOSONSTIGES',
}
registerEnum({ enum: DemoSalutationEnum, name: 'DemoSalutationEnum' });

export enum DemoOccupationEnum {
  DEMOPROF_GOETHE = 'DEMOPROF_GOETHE',
  DEMOSINCE_GOETHE = 'DEMOSINCE_GOETHE',
  DEMOTEACHER_GOETHE = 'DEMOTEACHER_GOETHE',
  DEMOHIWI_GOETHE = 'DEMOHIWI_GOETHE',
  DEMOEMPLOYEE_GOETHE = 'DEMOEMPLOYEE_GOETHE',
  DEMOTEACHER = 'DEMOTEACHER',
  DEMOHESS_HOCHSCHULANGEHOERIGE = 'DEMOHESS_HOCHSCHULANGEHOERIGE',
  DEMOSONSTIGE = 'DEMOSONSTIGE',
}
registerEnum({ enum: DemoOccupationEnum, name: 'DemoOccupationEnum' });

export enum DemoInstitutionEnum {
  DEMORECHT = 'DEMORECHT',
  DEMOWIRTSCHAFT = 'DEMOWIRTSCHAFT',
  DEMOGESELLSCHAFT = 'DEMOGESELLSCHAFT',
  DEMOERZIEHUNG = 'DEMOERZIEHUNG',
  DEMOPSYCHOLOGIE = 'DEMOPSYCHOLOGIE',
  DEMOEVANG_THEOLOGIE = 'DEMOEVANG_THEOLOGIE',
  DEMOKATH_THEOLOGIE = 'DEMOKATH_THEOLOGIE',
  DEMOPHILOSOPHIE = 'DEMOPHILOSOPHIE',
  DEMOSPRACHEN = 'DEMOSPRACHEN',
  DEMONEU_PHILOLOGIE = 'DEMONEU_PHILOLOGIE',
  DEMOGEO = 'DEMOGEO',
  DEMOINFORMATIK = 'DEMOINFORMATIK',
  DEMOPHYSIK = 'DEMOPHYSIK',
  DEMOCHEMIE = 'DEMOCHEMIE',
  DEMOBIOLOGIE = 'DEMOBIOLOGIE',
  DEMOMEDIZIN = 'DEMOMEDIZIN',
  DEMOEXTERN = 'DEMOEXTERN',
  DEMOZENTRALE = 'DEMOZENTRALE',
  DEMOOTHERS = 'DEMOOTHERS',
}
registerEnum({ enum: DemoInstitutionEnum, name: 'DemoInstitutionEnum' });
registerEnum({ enum: DemoInvoiceReceiverEnum, name: 'DemoInvoiceReceiverEnum' });

@Entity()
export class DemoStammdaten extends UserStammdaten {
  static override _class = 'DemoStammdaten';

  override getTranslationNamespace() {
    return 'demo';
  }

  @Field(type => DemoSalutationEnum)
  salutation: Maybe<DemoSalutationEnum>;

  @Field(type => String)
  title: Maybe<string>;

  @validate(and(nonOptional()))
  @Field(type => String)
  phoneNumber: Maybe<string>;

  @Field(type => DemoInstitutionEnum)
  department: Maybe<DemoInstitutionEnum>;

  @Field(type => String)
  attention: Maybe<string>;

  @validate(({ value, target, key }) => {
    const errorFields = (
      !target.address
        ? [{ path: ['address'], target }]
        : [
            !target.address?.streetAndHousenumber
              ? { path: ['address', 'streetAndHousenumber'], target: target.address }
              : null,
            ...(!target.address.zipCity
              ? [{ path: ['address', 'zipCity'], target: target.address }]
              : [
                  !target.address?.zipCity?.zip
                    ? { path: ['address', 'zipCity', 'zip'], target: target.address?.zipCity }
                    : null,
                  !target.address?.zipCity?.city
                    ? { path: ['address', 'zipCity', 'city'], target: target.address?.zipCity }
                    : null,
                ]),
          ]
    ).filter(Boolean) as Array<{ path: string[]; target: any }>;

    if (errorFields.length)
      throw new MultipleValidationError(
        errorFields.map(
          ({ path, target }) =>
            new ValidationError(`Key ${path.slice(-1)[0]} is required!`, {
              key: path.slice(-1)[0] as any,
              translationKey: 'validation_non_optional',
              path: path.slice(0, -1),
              target,
            }),
        ),
      );
  })
  @Field(type => Address, { default: v => v ?? new Address({}) })
  address: Maybe<Address>;
}
